// URL base del backend. Se puede sobreescribir sin tocar código creando un
// archivo .env (o .env.production / .env.development) con:
//   VUE_APP_API_URL=https://staging-api.raptoris.com
export const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://api.raptoris.com'

// Número de WhatsApp Business, formato internacional sin espacios ni "+"
// (México ya no usa el "1" extra desde 2019). Único lugar del proyecto
// donde vive el número (ver WhatsAppFloatButton.vue y CLAUDE.md).
export const WHATSAPP_NUMBER = '528117437479'
